import { useEffect, type ReactNode } from "react"

import LogoHorizontal from "@src/components/LogoHorizontal"
import SEO from "@src/components/seo"

export interface SplitScreenLayoutProps {
  children?: ReactNode
  browserTitle: string
  isLoading: boolean
  loadingText?: string
}

export default function SplitScreenLayout({
  children,
  browserTitle,
}: SplitScreenLayoutProps) {
  useEffect(() => {
    window.document.body.style.paddingTop = "0"
  }, [])

  return (
    <>
      <SEO noIndex={true} title={browserTitle} />
      <div className="flex min-h-screen flex-col">
        <header className="md:grid md:grid-cols-5">
          <div className="md:col-span-3">
            <div className="p-4 lg:max-w-3xl lg:ml-auto">
              <a href="/" className="block w-44">
                <LogoHorizontal />
              </a>
            </div>
          </div>
          <div className="bg-gray-200 border-l border-gray-300 hidden md:block md:col-span-2">
            {""}
          </div>
        </header>
        <div className="flex-1 md:grid md:grid-cols-5">{children}</div>
        <footer className="md:grid md:grid-cols-5">
          <div className="md:col-span-3">
            <div className="px-4 py-6 lg:max-w-3xl lg:ml-auto">
              <nav className="font-browser text-xs">
                <a
                  className="hover:underline mr-4"
                  href="/privacy-policy"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Privacy Policy
                </a>
                <a
                  className="hover:underline mr-4"
                  href="/terms-of-use"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Terms of Use
                </a>
                <a
                  className="hover:underline"
                  href="/returns"
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  Refund Policy
                </a>
              </nav>
            </div>
          </div>
          <div className="bg-gray-200 border-l border-gray-300 hidden md:block md:col-span-2">
            {""}
          </div>
        </footer>
      </div>
    </>
  )
}
